import React from 'react';

/**
 * Une boîte aux lettres : du texte avec une pastille. La couleur pleine reste
 * réservée au type du mail, pour qu'« info » en bleu ne se lise pas comme
 * « Fournisseur » en bleu.
 */
const COULEURS: Record<string, string> = {
  info: '#0d6efd',
  achats: '#198754',
  petretto: '#ffc107',
  'c.petretto': '#ffc107',
  web: '#0dcaf0',
};

export const Boite: React.FC<{ nom: string }> = ({ nom }) => (
  <span className="d-inline-flex align-items-center text-nowrap" style={{ gap: '6px', fontSize: '0.82rem' }}>
    <span style={{ width: 8, height: 8, borderRadius: '50%', background: COULEURS[nom] || '#adb5bd', flex: 'none' }}></span>
    {nom}
  </span>
);
